const audio = new Audio()
export default audio